/*
 * RANGI — pozycja bytu w zestawieniu, znormalizowana do 0…1.
 *
 * Wyciągnięte z komponentu Portfolio do osobnego modułu, bo to jest MATEMATYKA, a matematyka
 * ma być testowalna bez renderowania. Powód powstania w ogóle: mapowanie wartości wprost na
 * procent szerokości wywróciło się przy pierwszym realnym zbiorze — wszystkie dania miały
 * sprzedaż w tych samych pięciu szkołach, więc każdy punkt wylądował przy prawej krawędzi
 * i przykrył etykietę ćwiartki.
 */

/**
 * Zwraca dla każdej wartości jej pozycję w zestawieniu w zakresie 0…1.
 * Byty o RÓWNEJ wartości dostają tę samą pozycję — środek zajmowanego przedziału rang.
 */
export function rangi(wartosci: readonly number[]): number[] {
  const posortowane = wartosci.map((v, i) => ({ v, i })).sort((a, b) => a.v - b.v);
  const wynik = new Array<number>(wartosci.length).fill(0.5);
  const n = posortowane.length;
  let i = 0;
  while (i < n) {
    let j = i;
    while (j + 1 < n && posortowane[j + 1]!.v === posortowane[i]!.v) j += 1;
    const srodek = n > 1 ? (i + j) / 2 / (n - 1) : 0.5;
    for (let k = i; k <= j; k += 1) wynik[posortowane[k]!.i] = srodek;
    i = j + 1;
  }
  return wynik;
}

/**
 * Czy oś w ogóle RÓŻNICUJE byty w tym zbiorze.
 *
 * Gdy wszystkie wartości są równe, ranga daje każdemu bytowi 0.5 i wykres pokazuje jedną
 * kolumnę pośrodku. To jest poprawne, ale wygląda jak usterka — a bez podpisu czyta się jak
 * „wszystko jest przeciętne", zamiast „ta oś nic tu nie rozróżnia".
 */
export function osRoznicuje(wartosci: readonly number[]): boolean {
  if (wartosci.length < 2) return false;
  return wartosci.some((v) => v !== wartosci[0]);
}
